const sportsBikes = [
    {
      imgUrl: 'https://www.autowheels.pk/wp-content/uploads/2022/01/Sports-Bike-Price-in-Pakistan.jpg',
      name: 'Kawasaki Ninja',
      year: 2022,
      price: '8000$',
      description: 'A high-performance sports bike known for its speed and agility.',
      stared: 0,
      hoverstared: 0,
      isStaredTrue: false,
    },
    {
      imgUrl: 'https://imgd.aeplcdn.com/1280x720/n/cw/ec/49253/honda-cbr1000rr-left-front-three-quarter0.jpeg',
      name: 'Honda CBR1000RR',
      year: 2022,
      price: '8500$',
      description: 'The CBR1000RR is a popular choice among sportbike enthusiasts.',
      stared: 0,
      hoverstared: 0,
      isStaredTrue: false,
    },
    {
      imgUrl: 'https://www.pakgadi.com/bikeimages/yamaha-yzf-r1.jpg',
      name: 'Yamaha YZF-R1',
      year: 2022,
      price: '8200$',
      description: 'The YZF-R1 offers a combination of power and handling.',
      stared: 0,
      hoverstared: 0,
      isStaredTrue: false,
    },
    {
      imgUrl: 'https://www.motorguider.com/wp-content/uploads/2022/05/Suzuki-GSX-R1000-2022-Side-View.jpg',
      name: 'Suzuki GSX-R1000',
      year: 2022,
      price: '8300$',
      description: 'A renowned superbike loved by riders for its performance.',
      stared: 0,
      hoverstared: 0,
      isStaredTrue: false,
    },
    {
      imgUrl: 'https://ultimatemotorcycling.com/wp-content/uploads/2021/11/2022-ducati-panigale-v4-lineup-first-look-superbike-racing-motorcycle-track-day-1.jpg',
      name: 'Ducati Panigale V4',
      year: 2022,
      price: '9000$',
      description: 'The Panigale V4 is known for its Italian style and precision engineering.',
      stared: 0,
      hoverstared: 0,
      isStaredTrue: false,
    },
    {
      imgUrl: 'https://imgd.aeplcdn.com/476x268/bw/models/bmw-s1000-rr-2019-standard20190725105524.jpg',
      name: 'BMW S1000RR',
      year: 2022,
      price: '8800$',
      description: 'The S1000RR offers cutting-edge technology and performance.',
      stared: 0,
      hoverstared: 0,
      isStaredTrue: false,
    },
    {
      imgUrl: 'https://cache1.pakwheels.com/system/bike_model_pictures/1703/original/1.jpg?1668502618',
      name: 'Aprilia RSV4',
      year: 2022,
      price: '8400$',
      description: 'The RSV4 is a championship-winning superbike.',
      stared: 0,
      hoverstared: 0,
      isStaredTrue: false,
    },
    {
      imgUrl: 'https://www.cycleworld.com/resizer/tBaSA0RBVTzzvd2XDwDBpktQ1OI=/616x0/smart/cloudfront-us-east-1.images.arcpublishing.com/octane/H3MHZSGP3JBXZOIDT64BA2MUDA.jpg',
      name: 'KTM RC 390',
      year: 2022,
      price: '6000$',
      description: 'The KTM RC 390 is known for its agility and performance on the track.',
      stared: 0,
      hoverstared: 0,
      isStaredTrue: false,
    },
    {
      imgUrl: 'https://i0.wp.com/www.asphaltandrubber.com/wp-content/uploads/2015/03/2015-MV-Agusta-F4-RC-01.jpg?fit=2000%2C1331&ssl=1',
      name: 'MV Agusta F4',
      year: 2022,
      price: '9500$',
      description: 'The MV Agusta F4 is a premium Italian sportbike with distinctive styling.',
      stared: 0,
      hoverstared: 0,
      isStaredTrue: false,
    },
    {
      imgUrl: 'https://mcn-images.bauersecure.com/wp-images/4023/1440x960/2011triumph-daytona675rc.jpg?mode=max&quality=90&scale=down',
      name: 'Triumph Daytona 675',
      year: 2022,
      price: '7700$',
      description: 'The Daytona 675 is a British sportbike with a unique three-cylinder engine.',
      stared: 0,
      hoverstared: 0,
      isStaredTrue: false,
    },
    {
      imgUrl: 'https://timeless2wheels.com/wp-content/uploads/2021/10/Honda-VFR800.webp',
      name: 'Honda-VFR800',
      year: 2018,
      price: "3000$",
      description: "The Honda VFR800 (Interceptor) is a sport touring motorcycle made by Honda since 1998.[1] The model was the successor to the VFR750F and shares the V4 engine configuration with the Honda VF and VFR series.",
      stared: 0,
      hoverstared: 0,
      isStaredTrue: false
    },
    {
      imgUrl: 'https://media.techeblog.com/images/autonomous-batpod-batcycle-the-batman-movie.jpg',
      name: 'Future Bike',
      year: 2021,
      price: "6000$",
      description: "little description about future bike i have taken seen this image when i was searching batman bike",
      stared: 0,
      hoverstared: 0,
      isStaredTrue: false
    }
  ];
  
  export default sportsBikes;